import type {
  DataExampleDefinition,
  DataPoolMetadata,
} from '@robovision/data'


interface DatapoolMetadataParams {
  annotatedSampleCount: number
  classCount: number
  description?: string
  exampleDefinition?: DataExampleDefinition
  name: string
  poolId: string
  sampleCount: number
  slug: string

}

export class DatapoolMetadata {
  public annotatedSampleCount: number
  public classCount: number
  public description?: string
  public exampleDefinition?: DataExampleDefinition
  public name: string
  public poolId: string
  public sampleCount: number
  public slug: string

  constructor (params: DatapoolMetadataParams) {
    this.annotatedSampleCount = params.annotatedSampleCount
    this.classCount = params.classCount
    this.description = params.description
    this.exampleDefinition = params.exampleDefinition
    this.name = params.name
    this.poolId = params.poolId
    this.sampleCount = params.sampleCount
    this.slug = params.slug
  }

  public static fromResponse (data: DataPoolMetadata) {
    return new DatapoolMetadata({
      annotatedSampleCount: data.annotatedSampleCount,
      classCount: data.classCount,
      description: data.description,
      exampleDefinition: data.exampleDefinition,
      name: data.name,
      poolId: data.poolId,
      sampleCount: data.sampleCount,
      slug: data.slug,
    })
  }
}
